export default __webpack_public_path__ + "static/media/twitter-icon.c6e48e60.png";